import { logger } from "../../core/logging/logger";
import type { ConnectedServiceDomainApiService } from "../../core/net/connected-service-domain-api-service";
import type { Paginated } from "../../utils/pagination";
import type { Mandate } from "./mandate";

export class MandatesService {
  public constructor(private readonly serviceDomainApiService: ConnectedServiceDomainApiService) {}

  public async getMandates(offset?: number): Promise<Paginated<Mandate>> {
    try {
      const response = await this.serviceDomainApiService.instance.get("/mandates", {
        params: {
          offset,
        },
      });
      if (!response?.data) {
        throw new Error("Invalid response structure");
      }
      return response.data;
    } catch (error) {
      logger.debug("MandatesService", "Failed to get mandates", error);
      throw new Error(error instanceof Error ? error.message : String(error));
    }
  }

  public async opposeMandate(mandateId: string): Promise<Mandate> {
    try {
      const response = await this.serviceDomainApiService.instance.post(`/mandates/${mandateId}/oppose`);
      return response.data;
    } catch (error) {
      logger.debug("MandatesService", "Failed to oppose mandate", error);
      throw new Error(error);
    }
  }

  public async activateMandate(mandateId: string): Promise<Mandate> {
    try {
      const response = await this.serviceDomainApiService.instance.post(`/mandates/${mandateId}/activate`);
      if (!response.data || typeof response.data !== "object" || !response.data.id) {
        throw new Error("Invalid response structure");
      }
      return response.data;
    } catch (error) {
      logger.debug("MandatesService", "Failed to activate mandate", error);
      throw new Error(error);
    }
  }
}
